import { render, staticRenderFns } from "./NomenclaturasDetail.vue?vue&type=template&id=4d32faa2&scoped=true"
import script from "./NomenclaturasDetail.vue?vue&type=script&lang=js"
export * from "./NomenclaturasDetail.vue?vue&type=script&lang=js"
import style0 from "./NomenclaturasDetail.vue?vue&type=style&index=0&id=4d32faa2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d32faa2",
  null
  
)

export default component.exports